publishingApp.controller('dashboardCtrl', ['$scope', '$rootScope', '$state', 'dbData', '$cookies', '$uibModal', '$log', '$debounce', '$throttle', function ($scope, $rootScope, $state, dbData, $cookies, $uibModal, $log, $debounce, $throttle) {
    $rootScope.currentCourse = '';
    $rootScope.language_id = null;
    $scope.courseClone = false;
    $scope.courseDelete = false;
    $scope.notificationsCount = 0;
    $scope.showSpinner = true;
    $scope.searchQuery = '';

    // Load course statuses to the $scope
    $scope.courseStatuses = function () {
        dbData.get('get-statuses').then(function (response) {
            $scope.courseStatuses = response.data;
        });
    }();

    /**
     * Load all available paginated courses
     *
     * @param requestUrl (string) - api endpoint we call
     */
    var getAllCourses = function (page) {
        var page = page || 1;
        generateSearchQuery();

        setTimeout(function () {
            dbData.get('/api/courses' + $scope.searchQuery + "&page=" + page).then(function (response) {
                $rootScope.currentCourses = [];
                $scope.totalCourses = response.data.total;
                $scope.coursesPerPage = response.data.per_page;

                var from = (response.data.from === null) ? 0 : response.data.from;
                var to = (response.data.to === null) ? 0 : response.data.to;
                $scope.displayNumbers = from + '-' + to;

                if (typeof response.data.data == 'object' && $scope.totalCourses > 0) {

                    // If content is NOT paginated
                    angular.forEach(response.data.data, function (child, key) {
                        $rootScope.currentCourses.push(child);
                    });

                    if (response.data.total > response.data.per_page) {
                        generatePagination(response.data.total, response.data.per_page, response.data.current_page, '/api/courses' + $scope.searchQuery);
                    }

                    // Change value of showSpinner to false to hide the spinner when ng repeat is finished
                    $scope.$on('ngRepeatFinished', function (temp) {
                        $scope.showSpinner = false;

                        if ($('#search_by_status option')[0].value === "? string:all ?") {
                            $('#search_by_status option')[0].remove();
                        }
                    });
                }
                else {
                    $scope.showSpinner = false;
                }
            }, function (error) {
                $scope.pushAlerts('Unable to retrieve courses at this moment.');
            });
        }, 0);
    };

    // Initial call on load
    getAllCourses();

    function generatePagination(totalItems, itemsPerPage, page, url) {

        if (totalItems > itemsPerPage) {
            $('#pagination').pagination({
                items: totalItems,
                itemsOnPage: itemsPerPage,
                pages: Math.ceil(totalItems / itemsPerPage),
                cssStyle: 'light-theme',
                currentPage: page,
                hrefTextPrefix: url,
                onPageClick: function (pageNumber, e) {
                    getAllCourses(pageNumber);
                }
            });
        }

        return undefined;
    };

    function generateSearchQuery() {
        setTimeout(function () {

            // Reset search query
            $scope.searchQuery = '';

            for (var property in $scope.filterCoursesBy) {
                switch (property) {
                    case "course_id":
                        angular.forEach($scope.filterCoursesBy.course_id.trim().split(","), function (value, key) {
                            if (value !== "") {
                                $scope.searchQuery += "&ids[]=" + value;
                            }
                        });
                        break;
                    case "name":
                        $scope.searchQuery += '&name_like=' + $scope.filterCoursesBy[property];
                        break;
                    case "publisher_name":
                        $scope.searchQuery += '&name_in_course_publisher_like=' + $scope.filterCoursesBy[property];
                        break;
                    case "author_name":
                        $scope.searchQuery += '&name_in_user_like=' + $scope.filterCoursesBy[property];
                        break;
                    case "status_name":
                        if ($scope.filterCoursesBy[property] !== "") {
                            $scope.searchQuery += '&status_id=' + $scope.filterCoursesBy["status_id"];
                        }
                        break;
                    case "created_at_from":
                        $scope.searchQuery += '&created_at_after=' + $scope.filterCoursesBy[property];
                        break;
                    case "created_at_to":
                        $scope.searchQuery += '&created_at_before=' + $scope.filterCoursesBy[property];
                        break;
                }
            }

            // Replace first & with ?
            $scope.searchQuery = $scope.searchQuery.replace("&", "?");
        }, 0);
    };

    dbData.get('notifications').then(function (response) {
        $scope.notifications = [];
        angular.forEach(response.data, function (element, key) {

            if ($scope.notifications.length <= 10) {
                // Get specific date format, extra day, month and year from given date, then convert month to calendar month in string
                var date = new Date(element.created_at);
                var month = date.getUTCMonth();
                var day = date.getUTCDate();
                var year = date.getUTCFullYear();

                function monthName(number) {
                    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'];
                    return monthNames[number];
                }

                var data = {
                    monthYear: monthName(month) + ' ' + year,
                    day: day,
                    content: element.notify_body,
                    notification_class: 'notification_type_' + element.category_id,
                    read: element.read
                };

                $scope.notifications.splice(key, 1, data);
            }

            if (element.read == 0) {
                if ($scope.notificationsCount < 99) {
                    $scope.notificationsCount++;
                } else {
                    $scope.notificationsCount = '99+';
                }
            }
        });

    });

    $scope.duplicateCourse = function (element) {
        $scope.courseDelete = false;
        $scope.courseClone = true;

        $uibModal.open({
            templateUrl: '../angular/views/modals/module-manager/confirm-modal.html',
            scope: $scope,
            controller: function ($scope, $uibModalInstance) {

                $scope.courseName = element.name;
                $scope.cancelModal = function () {
                    $scope.courseClone = false;
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.submitModal = function () {
                    $scope.courseClone = false;
                    dbData.post('course/' + element.id + '/duplicate').then(function (response) {
                        $rootScope.currentCourses.push(response.data);
                        setTimeout(function () {
                            $state.go($state.current, {}, { reload: true });
                        }, 10);
                    }, function (error) { });
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };

    $scope.deleteCourse = function (element) {
        $scope.courseDelete = false;
        $scope.courseClone = false;
        $scope.deleteTreeItemModal = true;

        $uibModal.open({
            templateUrl: '../angular/views/modals/module-manager/confirm-modal.html',
            scope: $scope,
            controller: function ($scope, $uibModalInstance) {

                $scope.entity = { type: "course" };
                $scope.course = element.name;

                $scope.cancelModal = function () {
                    $scope.courseDelete = false;
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.submitModal = function () {

                    dbData.delete('courses/' + element.id).then(function (response) {
                        var correctIndex = $rootScope.currentCourses.indexOf(element);
                        $rootScope.currentCourse = '';
                        $scope.courseDelete = false;
                        $cookies.remove('courseID');
                        $rootScope.currentCourses.splice(correctIndex, 1);
                        $uibModalInstance.dismiss('cancel');
                    });

                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    /**
     * Returns view only information about the course (view only user)
     * @param course_id
     */
    $scope.viewOnly = function (course_id) {
        window.location.href = document.querySelector('body').dataset.pubHubUrl + '/course-structure/course/' + $rootScope.currentCourse
    };

    // Slide down/slide up search
    $('#advancedSearchBtn').click(function (e) {
        e.preventDefault();
        $('#filter-box').slideToggle();
    });

    // Toggle course dormant
    $('.is_dormant').on('change', function () {
        // if checkbox is checked, we need to send the opposite to the db
        var checkbox_state = ($(this).prop('checked')) ? 0 : 1;
        var course_id = $(this).attr('data-course_id');

        dbData.post('course-dormant/' + course_id + '/' + checkbox_state, data).then(function (response) {
            // post request success
        }, function (error) {
            // post request error
        });
    });

    // Variables for course filtering on the Dashboard
    $scope.filterCoursesBy = {
        course_id: '',
        name: '',
        publisher_name: '',
        author_name: '',
        status_name: '',
        status_id: '',
        created_at_from: '',
        created_at_to: '',
    };

    $scope.today = $.datepicker.formatDate("yy-mm-dd", new Date());

    // Variable to be saved to local storage
    $scope.savedFilters = {};

    // Read filter data from local storage
    if (typeof localStorage !== "undefined" && localStorage.getItem('savedFilters')) {

        // Slide down filter box
        $('#dashboard #filter-box').slideDown();

        // Parse JSON string from local storage
        $scope.savedFilters = JSON.parse(localStorage.getItem('savedFilters'));

        // Populate filters from data retrieved
        $scope.filterCoursesBy = {
            course_id: ($scope.savedFilters.search_by_course_id) ? $scope.savedFilters.search_by_course_id : '',
            name: ($scope.savedFilters.search_by_name) ? $scope.savedFilters.search_by_name : '',
            publisher_name: ($scope.savedFilters.search_by_publisher) ? $scope.savedFilters.search_by_publisher : '',
            author_name: ($scope.savedFilters.search_by_user) ? $scope.savedFilters.search_by_user : '',
            status_name: ($scope.savedFilters.search_by_status) ? $scope.savedFilters.search_by_status : '',
            status_id: ($scope.savedFilters.search_by_status_id) ? $scope.savedFilters.search_by_status_id : '',
            created_at_from: ($scope.savedFilters.search_by_from_date) ? $scope.savedFilters.search_by_from_date : '',
            created_at_to: ($scope.savedFilters.search_by_to_date) ? $scope.savedFilters.search_by_to_date : '',
        };

        $scope.showSpinner = false;
    }

    var triggerDebouncedFilterWrap = function () {
        if ($('input#search_by_course_id')[0].value.length >= 0) {
            $scope.savedFilters.search_by_course_id = $('input#search_by_course_id')[0].value;
        }
        if ($('input#search_by_name')[0].value.length >= 0) {
            $scope.savedFilters.search_by_name = $('input#search_by_name')[0].value;
        }
        if ($('input#search_by_publisher')[0].value.length >= 0) {
            $scope.savedFilters.search_by_publisher = $('input#search_by_publisher')[0].value;
        }
        if ($('input#search_by_user')[0].value.length >= 0) {
            $scope.savedFilters.search_by_user = $('input#search_by_user')[0].value;
        }
        if ($('input#search_by_from_date')[0].value.length >= 0) {
            $scope.savedFilters.search_by_from_date = $('input#search_by_from_date')[0].value;
        }
        if ($('input#search_by_to_date')[0].value.length >= 0) {
            $scope.savedFilters.search_by_to_date = $('input#search_by_to_date')[0].value;
        }
        if ($('select#search_by_status')[0].value.length >= 0) {
            $scope.savedFilters.search_by_status = $('select#search_by_status')[0].selectedOptions[0].innerHTML;
            $scope.savedFilters.search_by_status_id = ($('select#search_by_status')[0].selectedOptions[0].attributes['data-status_id']) ? parseInt($('select#search_by_status')[0].selectedOptions[0].attributes['data-status_id'].value) : "";
            $scope.filterCoursesBy.status_id = $scope.savedFilters.search_by_status_id;

            if ($scope.savedFilters.search_by_status === 'All') {
                $scope.savedFilters.search_by_status = '';
                $scope.savedFilters.search_by_status_id = '';
            }
        }
        if (typeof localStorage !== "undefined") {
            localStorage.setItem('savedFilters', JSON.stringify($scope.savedFilters));
        }
        getAllCourses();
    };

    $scope.triggerDebouncedFilter = function () {
        $debounce(triggerDebouncedFilterWrap, 500, false);
    };

    $scope.$on('$destroy', function () {
        $(document.body).off('search', '#filter-box > .input-box input');
        $('body').off('change', 'select.course_status');
    });


    // Clear filters when input cross is pressed
    $(document.body).on('search', '#filter-box > .input-box input', function (e) {
        if ($(this)[0].id === 'search_by_course_id') {
            $scope.savedFilters.search_by_course_id = '';
            $scope.filterCoursesBy.course_id = '';
        }

        if ($(this)[0].id === 'search_by_name') {
            $scope.savedFilters.search_by_name = '';
            $scope.filterCoursesBy.name = '';
        }

        if ($(this)[0].id === 'search_by_publisher') {
            $scope.savedFilters.search_by_publisher = '';
            $scope.filterCoursesBy.publisher_name = '';
        }

        if ($(this)[0].id === 'search_by_user') {
            $scope.savedFilters.search_by_user = '';
            $scope.filterCoursesBy.author_name = '';
        }

        if ($(this)[0].id === 'search_by_from_date') {
            $scope.savedFilters.search_by_from_date = '';
            $scope.filterCoursesBy.created_at_from = '';
        }

        if ($(this)[0].id === 'search_by_to_date') {
            $scope.savedFilters.search_by_to_date = '';
            $scope.filterCoursesBy.created_at_to = '';
        }
        if (typeof localStorage !== "undefined") {
            localStorage.setItem('savedFilters', JSON.stringify($scope.savedFilters));
        }
        // Make a call
        getAllCourses();
    });

    // On change event for select course status
    $('body').on('change', 'select.course_status', function () {
        var data = ($(this).find(":selected").data("value"));   // get selected data-value combination
        if (typeof data !== "undefined") {
            var result = data.split('---');     // explode data to retrieve status id and lock state
            // pass parameters to ajax
            $scope.changeStatus($(this).attr('data-course-id'), parseInt(result[0]), parseInt(result[1]));
        }

        // revert select options back to the default
        $(this).find(":nth-child(1)").prop('selected', true);
    });

    // Update course status
    $scope.changeStatus = function (course_id, status_id, locked_status) {
        // As a precaution check if user is and administrator
        if ($rootScope.userCan($rootScope.user.permissions, ['course-published-full-reedit'])) {

            dbData.post('api/courses/' + course_id + '/status/' + status_id).then(function (response) {
                angular.forEach($rootScope.currentCourses, function (course, key) {
                    if (course.id == course_id) {

                        // Set course lock state, retireve updated status id and status name
                        course.lock_state = locked_status;
                        course.status_id = response.data.status_id;
                        course.status_name = response.data.status_name;
                    }
                });
            });
        }
    };

    // Datepicker for date range filter
    $(function () {
        var dateFormat = "yy-mm-dd",
            from = $("#search_by_from_date")
                .datepicker({
                    changeMonth: true,
                    numberOfMonths: 1,
                    dateFormat: dateFormat
                })
                .on("change", function () {
                    to.datepicker("option", "minDate", getDate(this));
                }),
            to = $("#search_by_to_date").datepicker({
                changeMonth: true,
                numberOfMonths: 1,
                dateFormat: dateFormat,
            })
                .on("change", function () {
                    from.datepicker("option", "maxDate", getDate(this));

                    if ($(this).hasClass('ng-empty')) {
                        $scope.filterCoursesBy.created_at_to = $scope.today;
                        $(this).val($scope.today);
                        $(this).blur();
                    }
                });

        function getDate(element) {
            var date;
            try {
                date = $.datepicker.parseDate(dateFormat, element.value);
            } catch (error) {
                date = null;
            }

            return date;
        }
    });

    // Clear filters
    $scope.clearFilters = function () {
        // Clear filters in the view
        $scope.savedFilters = {};
        $scope.filterCoursesBy = {};
        $scope.filterCoursesBy.created_at_to = $.datepicker.formatDate("yy-mm-dd", new Date());

        // Make a call
        getAllCourses();

        // Clear filters in the storage
        if (typeof localStorage !== "undefined" && localStorage.getItem('savedFilters')) {
            localStorage.removeItem('savedFilters');
        }
    };

    // Are filters set
    $scope.filtersSet = function () {
        var areFiltersSet = false;

        for (var property in $scope.filterCoursesBy) {
            if ($scope.filterCoursesBy[property] !== "" && property !== "created_at_to") {
                areFiltersSet = true;
                break;
            }
        }

        return areFiltersSet;
    };

    // Navigate to Module Manager and set correct course_id
    $scope.goToModuleManager = function (course_id) {
        $cookies.put('courseID', course_id);
        $rootScope.currentCourse = course_id.id;
        window.location.href = document.querySelector('body').dataset.pubHubUrl + '/course-structure/course/' + course_id.id;
    };

    $scope.buttonConditionalAction = function (course, buttonType) {
        switch (buttonType) {
            /**
             * if:
             *  - course is in status 8 (re-edit info) and user can re-edit info -> allow re-edit info only
             *
             *  - course is in status 9 (re-edit full) and user can re-edit full OR
             *  - regardless of lock state if user cam re-edit info OR
             *  - if course is in status 5 (published, locked) or 11 (approved test course) regardless of the lock OR
             *  - if course is not locked
             */
            case "edit":
                if ($rootScope.userCan($rootScope.user.permissions, ['course-published-full-reedit']) && course.status_id === 9) {
                    // user can re-edit full course and course is open for full re-editing
                    $scope.goToModuleManager(course);
                } else if ($rootScope.userCan($rootScope.user.permissions, ['course-publish'])) {
                    // course might be locked but the user has permission to re-edit information
                    $scope.goToModuleManager(course);
                } else if ([5, 11].includes(course.status_id)) {
                    $scope.goToModuleManager(course);
                } else if (!(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id)) {
                    // the course is not locked
                    $scope.goToModuleManager(course);
                }
                break;
            case "duplicate":
                if ($rootScope.userCan($rootScope.user.permissions, ['course-duplicate']) ||
                    !(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id)) {

                    $scope.duplicateCourse(course);
                }

                break;
            case "delete":
                if ($rootScope.userCan($rootScope.user.permissions, ['course-delete']) ||
                    !(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id)) {

                    $scope.deleteCourse(course);
                }

                break;
        }
    };

    $scope.updateCourseDevelopmentCosts = function (course) {
        var newValueInCents = course.development_costs.amount_cents;
        console.log(newValueInCents);
        var developmentCostsExists = course.development_costs.id !== undefined;
        if (developmentCostsExists) {
            dbData.put('api/courses/' + course.id + '/development-costs/' + course.development_costs.id, { 'amount_cents': newValueInCents }).then(
                function (response) {
                    $scope.pushAlerts('Course development costs for course ID ' + course.id + ' were updated');
                    getAllCourses();
                }, function (error) {
                    $log.error(error);
                }
            );
        } else {
            dbData.post('api/courses/' + course.id + '/development-costs', { 'amount_cents': newValueInCents }).then(
                function (response) {
                    $scope.pushAlerts('Course development costs for course ID ' + course.id + ' were added');
                    getAllCourses();
                }, function (error) {
                    $log.error(error);
                }
            );
        }
    }

    $scope.updateCourseDiscount = function (course) {
        var newValueInCents = course.development_costs.discount_amount_cents;
        console.log(newValueInCents);
        var developmentCostsExists = course.development_costs.id !== undefined;
        if (developmentCostsExists) {
            dbData.put('api/courses/' + course.id + '/development-costs/' + course.development_costs.id, { 'discount_amount_cents': newValueInCents }).then(
                function (response) {
                    $scope.pushAlerts('Course development costs discount for course ID ' + course.id + ' was updated');
                    getAllCourses();
                }, function (error) {
                    $log.error(error);
                }
            );
        } else {
            dbData.post('api/courses/' + course.id + '/development-costs', { 'discount_amount_cents': newValueInCents }).then(
                function (response) {
                    $scope.pushAlerts('Course development costs discount for course ID ' + course.id + ' was added');
                    getAllCourses();
                }, function (error) {
                    $log.error(error);
                }
            );
        }
    }

    $scope.buttonConditionalDisabling = function (course, buttonType) {
        switch (buttonType) {
            case "edit":
                if ($rootScope.userCan($rootScope.user.permissions, ['course-published-full-reedit']) && course.status_id === 9) {
                    return false;
                } else if ($rootScope.userCan($rootScope.user.permissions, ['course-publish'])) {
                    return false;
                } else if ([5, 11].includes(course.status_id)) {
                    return false;
                } else return !(!(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id));

            case "duplicate":
                return !($rootScope.userCan($rootScope.user.permissions, ['course-duplicate']) ||
                    !(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id));
            case "delete":
                return !($rootScope.userCan($rootScope.user.permissions, ['course-delete']) ||
                    !(course.lock_state || course.dormant) && ![8, 9].includes(course.status_id));

        }
    };
}]);